module.exports = __webpack_public_path__ + "static/media/arxontisa-cover.8af7f802.jpg";